import React from "react";
import Typography from "material-ui/Typography";
import TextField from "material-ui/TextField";
import Icon from "material-ui/Icon";
import IconButton from "material-ui/IconButton";
import Button from "material-ui/Button";
import Title from "../../ui/title";
import Checkbox from "material-ui/Checkbox";
import Select from "material-ui/Select";
import { MenuItem } from "material-ui/Menu";
import { RadioGroup, Divider, Grid, Radio } from "material-ui";
import Content from "../../ui/content";
import { withStyles } from "material-ui/styles";
import Input, { InputLabel } from "material-ui/Input";
import styles from "./styles";
import AddCable from "../common/addCable";
import ConfirmDialog from "../../common/dialog/confirm";
import { validateFormData } from "../../../common/formtool";
import Back from "../../ui/back";
import BackCheck from "../../ui/backCheck";
import { withRouter } from "react-router-dom";
import {
  FormLabel,
  FormControl,
  FormControlLabel,
  FormHelperText
} from "material-ui/Form";
import STWiremapDiagram from "../common/stdiagram";
import STWiremapGenerator from "../../../common/stwiremapGenerator";

import NoData from "../../nodata";
import { DispPrefEnum } from "../wiremap/wiremapenum";

class WireMapCustCable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      wireMap: this.props.wireMap,
      cableList: this.props.cableList,
      id: "",
      customerid: this.props.customerId,
      name: "",
      pin1connected: null,
      pin2connected: null,
      pin3connected: null,
      pin4connected: null,
      pin5connected: null,
      pin6connected: null,
      pin7connected: null,
      pin8connected: null,
      shield: null,
      formatData: [],
      searchModal: false,
      isAdd: false,
      isEdit: false,
      cableDetail: [],
      isChanged: false,
      deleteCable: {},
      showConfirmDelete: false,
      isCustomerPage: this.props.isEditCustomer,
      wiremapStandard:
        this.props.wireMap && this.props.wireMap.displayprefid != null
          ? DispPrefEnum.find(o => o.value === this.props.wireMap.displayprefid)
              .key
          : "568B"
    };
    this.onCableAddSubmit = this.onCableAddSubmit.bind(this);
    this.onTargetConfirmDelete = this.onTargetConfirmDelete.bind(this);
  }
  componentWillMount() {
    this.props.getWireMap();
    if (!this.state.isCustomerPage) {
      this.props.getCableList(null); //THIS GETS CALLED
    }
    // let formattedDataList;
    // if (this.props.cableList) {
    //   formattedDataList = this.formatData(this.props.cableList);
    // }
    this.updateCableListState(this.props.cableList);
  }
  componentWillReceiveProps(nextProps) {
    const { cableList, wireMap } = nextProps;
    if (cableList && this.props.cableList != cableList) {
      //this.updateCableListState(cableList);
      // this.setState({
      //   cableList: cableList //GETS UPDATED
      // });
      this.updateCableListState(cableList); //THIS UPDATES THE VALUES
    }
    if (wireMap && this.props.wireMap != wireMap) {
      this.setState({
        wiremapStandard:
          wireMap && wireMap.displayprefid != null
            ? DispPrefEnum.find(o => o.value === wireMap.displayprefid).key
            : "568B"
      });
    }
  }
  updateCableListState = cableList => {
    this.setState({
      cableList
    });
    if (cableList) {
      let formattedDataList = this.formatData(cableList);
    }
  };

  onCableAddOpen = () => {
    let arr = [];
    let cableDetail = [];
    for (let i = 0; i < 9; i++) {
      arr.push({
        DHPin: (i + 1).toString(),
        IsCross: false,
        IsOpen: false,
        IsReverse: false,
        IsShort: false,
        IsSplit: false,
        IsThru: i == 8 ? true : false,
        IsUndefined: false
      });
    }
    cableDetail = {
      RefLength: 24.1,
      Details: arr,
      name: "Cable " + (this.state.cableList.length + 1)
    };

    this.setState({
      isAdd: true,
      isEdit: false,
      searchModal: true,
      cableDetail
    });
  };

  onCableAddClose = () => {
    this.setState({
      searchModal: false,
      isAdd: false,
      isEdit: false
    });
  };

  onCableSearchSelect = selectedCable => {};

  onCableAddSubmit = (pinList, cableName, id) => {
    //add this cable to state.cableList
    let cableList = [...this.state.cableList];
    let cable = {
      id: id,
      customerid: this.state.customerid,
      name: cableName,
      pin1connected: pinList.indexOf(1) >= 0 ? true : false,
      pin2connected: pinList.indexOf(2) >= 0 ? true : false,
      pin3connected: pinList.indexOf(3) >= 0 ? true : false,
      pin4connected: pinList.indexOf(4) >= 0 ? true : false,
      pin5connected: pinList.indexOf(5) >= 0 ? true : false,
      pin6connected: pinList.indexOf(6) >= 0 ? true : false,
      pin7connected: pinList.indexOf(7) >= 0 ? true : false,
      pin8connected: pinList.indexOf(8) >= 0 ? true : false,
      shield: true
    };
    this.props.updateCableList(cable);
    this.setState({
      searchModal: false,
      isAdd: false,
      isEdit: false,
      isChanged: true
    });
    //this.formatData(cableList);
  };

  onCableEdit = item => {
    let arr = [];
    for (let i = 0; i < 9; i++) {
      arr.push({
        DHPin: (i + 1).toString(),
        IsCross: false,
        IsOpen: item.Details[i].IsOpen,
        IsReverse: false,
        IsShort: false,
        IsSplit: false,
        IsThru: item.Details[i].IsThru,
        IsUndefined: false
      });
    }
    item["Details"] = arr;
    this.setState({
      isAdd: false,
      isEdit: true,
      searchModal: true,
      cableDetail: item
    });
  };
  onCableDelete = item => {
    //this.setState({ isChanged: true });
    this.setState({ showConfirmDelete: true, deleteCable: item });
  };
  onTargetConfirmDelete = () => {
    this.state.isCustomerPage
      ? this.props.DeleteCable(this.state.deleteCable.id, this.state.customerid)
      : this.props.DeleteCable(this.state.deleteCable.id, null);
    this.setState({
      isChanged: true,
      deleteCable: {},
      showConfirmDelete: false
    });
  };
  hideConfirmModal = () => {
    this.setState({
      showConfirmDelete: false,
      isChanged: false,
      deleteCable: {}
    });
  };

  formatData = cableList => {
    let formattedData = [];
    for (let item in cableList) {
      let cable = cableList[item];
      let arr = [];
      for (let i = 0; i < 9; i++) {
        arr.push({
          DHPin: (i + 1).toString(),
          IsCross: false,
          IsOpen: cable["pin" + (i + 1).toString() + "connected"]
            ? false
            : true,
          IsReverse: false,
          IsShort: false,
          IsSplit: false,
          IsThru: cable["pin" + (i + 1).toString() + "connected"]
            ? true
            : false,
          IsUndefined: false
        });
      }
      if (cable.shield == true) {
        arr[8].IsThru = true;
        arr[8].IsOpen = false;
      } else {
        arr[8].IsThru = false;
        arr[8].IsOpen = true;
      }
      formattedData.push({ RefLength: 24.1, Details: arr, ...cableList[item] });
    }
    this.setState({
      formattedData
    });
    return formattedData;
  };

  onBackClick = () => {
    // if (this.state.isChanged) {
    //   this.setState({
    //     showConfirmBack: true
    //   });
    // }
  };
  onBackYesClick = () => {
    // this.onUpTimeSave();
    // this.setState({
    //   showConfirmBack: false
    // });
  };
  onBackNoClick = () => {
    //this.props.history.push("/subtestsettings");
  };
  hideBackConfirmModal = () => {
    // this.setState({
    //   showConfirmBack: false
    // });
  };

  render() {
    const { translate, classes } = this.props;
    const {
      wireMap,
      displayprefid,
      cabletypeid,
      usecustomnvp,
      customnvp,
      shieldtypeid,
      detectsplitpair,
      crossoverallowed,
      customcable,
      customcablepins,
      errors,
      searchModal,
      isChanged,
      cableList,
      formattedData,
      cableDetail,
      isAdd,
      isEdit,
      deleteCable,
      isCustomerPage,
      customerid,
      wiremapStandard
    } = this.state;
    //subtestResultsWiremap

    let $modal = null;
    if (searchModal) {
      $modal = (
        <AddCable
          //languages={languages}
          modal={searchModal}
          onClose={this.onCableAddClose}
          onCableAddSubmit={this.onCableAddSubmit}
          cableDetail={cableDetail}
          selectCable={this.onCableSearchSelect}
          translate={translate}
          isEdit={isEdit}
          isAdd={isAdd}
          wiremapStandard={wiremapStandard}
          //selectedTest={selectedTest.includes("traceroute4") ? "IPv4" : "IPv6"}
        />
      );
    }

    return (
      <div style={{marginTop: "215px"}}>
        {!this.props.isEditCustomer ? (
          <Title
            back={
              <Back
                link={"/subtestsettings"}
                title={translate("general_sub_test_settings")}
              />
            }
            // backCheck={
            //   isChanged && (
            //     <BackCheck
            //       toCheck={this.onBackClick}
            //       title={translate("general_sub_test_settings")}
            //     />
            //   )
            // }
            title={translate("general_sub_test_wiremap_cust_head")}
          />
        ) : null}
        <Content translate={translate}>
          <Grid container spacing={1}>
            {!isCustomerPage && <Grid item xs={2}></Grid>}
            <Grid item xs={!isCustomerPage ? 8 : 12}>
              <Grid item xs={!isCustomerPage ? 8 : 12} sm={12}>
                {cableList && cableList.length == 20 ? (
                  <Typography type="subheading" className={classes.lengthText}>
                    {translate("cable_limit_validation_text")}
                  </Typography>
                ) : null}
              </Grid>
              <Grid item xs={!isCustomerPage ? 8 : 12} sm={12}>
                <div className={classes.targetHeading}>
                  <Typography type="subheading" className={classes.modalHeader}>
                    {translate("wiremap_cust_cab_header")}
                  </Typography>
                  <Button
                    color="primary"
                    onClick={() => this.onCableAddOpen()}
                    disabled={cableList && cableList.length == 20}
                  >
                    <Icon> add </Icon>{" "}
                    {translate("general_sub_test_wiremap_add_cust_cable")}
                  </Button>
                </div>
              </Grid>
              <Grid item xs={!isCustomerPage ? 8 : 12} sm={12}>
                <Divider />
              </Grid>
              <Grid item xs={!isCustomerPage ? 8 : 12} sm={12}>
                {formattedData && formattedData.length > 0 ? (
                  formattedData.map((item, key) => {
                    //let nos = key + 1;
                    return (
                      <div>
                        <div className={classes.targetHeading}>
                          <Grid item xs={4}>
                            <Typography type="subheading">
                              {(key + 1).toString() + ". " + item.name}
                            </Typography>
                            <Button
                              color="primary"
                              onClick={() =>
                                this.onCableEdit(
                                  JSON.parse(JSON.stringify(item))
                                )
                              }
                              //disabled={customerTargets && customerTargets.length == 10}
                            >
                              <Icon> edit </Icon> {translate("general_edit")}
                            </Button>
                            <span className={classes.divider} />
                            <Button
                              color="primary"
                              onClick={() => this.onCableDelete(item)}
                              //disabled={customerTargets && customerTargets.length == 10}
                            >
                              <Icon> delete </Icon>{" "}
                              {translate("general_delete")}
                            </Button>
                          </Grid>
                          <Grid item xs={8} className={classes.wiremap}>
                            {/* <TextField
                              //className={classes.textFieldR}
                              // error={errors.contactfirstname}
                              key={key}
                              id={item.id}
                              name={item.customerid}
                              label={item.customerid}
                              margin="normal"
                              value={item.customerid}
                            /> */}
                            <STWiremapDiagram
                              data={item}
                              translate={translate}
                              wiremapStandard={wiremapStandard}
                              isAdd={isAdd}
                              isEdit={isEdit}
                            />
                          </Grid>
                        </div>
                        <Divider />
                      </div>
                    );
                  })
                ) : (
                  <NoData
                    translate={translate}
                    noDataText="subtest_wiremap_custom_cable_empty"
                  />
                )}
              </Grid>
            </Grid>
            {!isCustomerPage && <Grid item xs={2}></Grid>}
          </Grid>
          {$modal}
          <ConfirmDialog
            open={this.state.showConfirmDelete}
            title={translate("general_sub_test_wiremap_cust_head")}
            contentText={
              deleteCable && deleteCable.name
                ? translate("cust_cable_delete_confirm_text", {
                    name: deleteCable.name
                  })
                : translate("cust_cable_delete_confirm_text")
            }
            contentSecondaryText={translate("general_confirmation_help_2")}
            okText={translate("general_confirm")}
            cancelText={translate("general_cancel")}
            onOk={this.onTargetConfirmDelete}
            onCancel={this.hideConfirmModal}
          />
        </Content>
      </div>
    );
  }
}
export default withRouter(withStyles(styles)(WireMapCustCable));



// WEBPACK FOOTER //
// ./src/components/subtestsetting/wiremapcustcable/index.js